export function calculateInstallmentValue(
  value: number,
  rate: number,
  installments: number,
): number {
  if (installments <= 1) {
    return value;
  }
  if (rate <= 0) {
    return value / installments;
  }
  const r = rate / 100;
  return (
    (value * (r * Math.pow(1 + r, installments))) /
    (Math.pow(1 + r, installments) - 1)
  );
}

export function calculateTotalPaidByCustomer(
  value: number,
  rate: number,
  installments: number,
): number {
  if (installments <= 1) {
    return value;
  }
  const installmentValue = calculateInstallmentValue(value, rate, installments);
  return installmentValue * installments;
}
